<template>
  <div class="custom-field">
    <custom-field-label :field="field" />

    <v-autocomplete
      color="primary"
      variant="outlined"
      :required="field.required"
      :model-value="uniqueModelValue"
      :rules="validationRules"
      :items="field.dropDownValues"
      clearable
      :placeholder="field.description"
      open-on-clear
      :menu-props="{ maxHeight }"
      multiple
      @update:model-value="onSelection"></v-autocomplete>
  </div>
</template>

<script>
import customFieldTypeMixin from '@/components/custom_fields/mixins/customFieldTypeMixin';
import { uniqDropDownMultiSelectValues } from '@nova/core';
import { isMobile } from '@/util';

export default {
  mixins: [customFieldTypeMixin],
  computed: {
    maxHeight() {
      return isMobile() ? 150 : 500;
    },
    uniqueModelValue() {
      return uniqDropDownMultiSelectValues(this.field.value);
    }
  },
  methods: {
    onSelection(value) {
      this.field.value = uniqDropDownMultiSelectValues(value);
    }
  }
};
</script>
